import { Dispatch } from 'redux';

import { FOOTER_ADJUST_FOOTER_LINKS, FOOTER_SET_VISIBILITY } from '../action-types';

export type adjustFooterLinksPayload = {
  isAdjusted: boolean;
  adjustedHeight?: number;
};

export type adjustFooterLinksAction = {
  type: typeof FOOTER_ADJUST_FOOTER_LINKS;
  payload: adjustFooterLinksPayload;
};

export type setVisibilityAction = {
  type: typeof FOOTER_SET_VISIBILITY;
  payload?: boolean;
};

const setAdjustFooterLinks =
  (adjustFooterLinks?: adjustFooterLinksPayload) => (dispatch: Dispatch<adjustFooterLinksAction>) => {
    const adjustedHeight = adjustFooterLinks?.isAdjusted ? adjustFooterLinks.adjustedHeight ?? 0 : 0;
    const payload: adjustFooterLinksPayload = {
      adjustedHeight,
      isAdjusted: adjustFooterLinks?.isAdjusted ?? false,
    };
    dispatch({ payload, type: FOOTER_ADJUST_FOOTER_LINKS });
  };

const setVisibility = (isVisible?: boolean) => (dispatch: Dispatch<setVisibilityAction>) => {
  dispatch({ payload: isVisible, type: FOOTER_SET_VISIBILITY });
};

export default { setAdjustFooterLinks, setVisibility };
